// extracted by mini-css-extract-plugin
module.exports = {"trigger":"_16624","down":"_1636"};